import React, { Component } from 'react';
import { Polygon as GooglePolygon, InfoWindow } from '@react-google-maps/api';
import { Grid } from '@mui/material';

const { google } = window;

function getPolygonBoundsCenter(polygonPath) {
  const bounds = new google.maps.LatLngBounds();
  polygonPath.forEach((element) => bounds.extend(element));
  return bounds.getCenter();
}

class Polygon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovering: false,
      infoWindowCoords: new google.maps.LatLng(),
    };

    this.polygonRef = React.createRef(null);
    this.setHovering = this.setHovering.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.onHover = this.onHover.bind(this);
  }

  onHover(event) {
    this.setHovering(true);
    this.setState({ infoWindowCoords: event.latLng });
  }

  setHovering(val) {
    this.setState({ hovering: val });
  }

  onLoad(polygon) {
    this.polygonRef.current = polygon;
  }

  render() {
    const {
      zone, polygon, editable, onZoneBoundaryEdit, showLabels, count,
    } = this.props;

    const { hovering, infoWindowCoords } = this.state;

    const polygonPathLength = polygon.paths.length;
    const polygonCenter = getPolygonBoundsCenter(polygon.paths);
    const tooltipVisible = showLabels && polygonPathLength > 0;

    return (
      <div>
        <GooglePolygon
          paths={polygon.paths}
          onMouseUp={() => (editable
            ? onZoneBoundaryEdit(this.polygonRef.current.getPath().getArray())
            : null
          )}
          onMouseOver={this.onHover}
          onMouseOut={() => this.setHovering(false)}
          onLoad={this.onLoad}
          options={{
            fillColor: polygon.fillColor,
            strokeWeight: 1,
            editable,
            clickable: zone.isPickup === true,
          }}
        />
        {(tooltipVisible || hovering) && (
          <InfoWindow position={tooltipVisible ? polygonCenter : infoWindowCoords}>
            <Grid container>
              <Grid item xs={12} style={{ fontWeight: 'bold' }}>
                {zone.name}
              </Grid>
              <Grid item xs={12}>
                {zone.category}
              </Grid>
              {count > 0 && (
                <Grid item xs={12}>
                  {count}
                  {' '}
                  vehicles
                </Grid>
              )}
            </Grid>
          </InfoWindow>
        )}
      </div>
    );
  }
}

export default Polygon;
